import { Link } from '@/i18n/navigation';
import { cn } from '@/lib/utils/cn';
import { ChevronRight } from 'lucide-react';
import type { ComponentProps } from 'react';
import type { LocalizedHref } from '@/lib/config/routes';

export type BreadcrumbHref = LocalizedHref;

export interface BreadcrumbItem {
  label: string;
  href?: BreadcrumbHref;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

export function Breadcrumb({ items, className }: BreadcrumbProps) {
  if (items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className={cn('w-full', className)}>
      <ol className="flex flex-wrap items-center gap-2 text-sm text-muted-foreground">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.href && !isLast ? (
                <Link
                  href={item.href as ComponentProps<typeof Link>['href']}
                  className="transition-colors hover:text-foreground"
                >
                  {item.label}
                </Link>
              ) : (
                <span aria-current="page" className="text-foreground">
                  {item.label}
                </span>
              )}
              {!isLast ? <ChevronRight className="size-4 shrink-0" aria-hidden="true" /> : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
